// extracted by mini-css-extract-plugin
export default {"products":"Us-z","card":"Vs-z","oosMessaging":"Ws-z"};